import { RAID_METADATA_BY_SLUG } from '../../../../../shared/enums';
import RaidRankingsLoader from '../raidRankingsLoader';
import { RaidRankingsContentFrontpage } from './raidRankingsContentFrontpage';
import apiService from '../../../services/apiService';
import { createActionGetRaidRankings } from '../../../actions/getRaidRankings';
import _ from 'lodash';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';


export type TRaidPartitionsPaneProps = {
  enabled: boolean;
  raidSlug: string;
  seasonSlug: string;
  difficulty: string;
  region: string;
  realm?: string;
};

export function RaidPartitionsPane(props: TRaidPartitionsPaneProps) {
  if (!props.enabled) {
    return null;
  }

  const raidMeta = RAID_METADATA_BY_SLUG[props.raidSlug];
  if (!raidMeta?.partitions?.length) {
    return null;
  }

  return (
    <Row gutter={['xxx-small', 'xx-small']} className="slds-m-top--small">
      {raidMeta.partitions.map((partition) => {
        const opensAt = partition.opensAt?.[props.region] ?? partition.opensAt?.us;
        return (
          <Col xs={12} md={4} key={partition.slug} className="slds-is-relative">
            <RaidRankingsLoader
              component={RaidRankingsContentFrontpage}
              limit={5}
              title={partition.name}
              raid={props.raidSlug}
              partition={partition.slug}
              partitionOpensAt={opensAt?.format()}
              difficulty={props.difficulty}
              region={props.region}
              realm={props.realm || 'all'}
              instanceId={`frontpage:raid:partition:${props.region}:${props.realm || 'all'}:${props.raidSlug}:${partition.slug}`}
              ignoreErrors={true}
              controlledDifficulty={false}
            />
          </Col>
        );
      })}
    </Row>
  );
}

(RaidPartitionsPane as any).preloadComponentActions = async (props: TRaidPartitionsPaneProps, params: any) => {
  if (!props.enabled) {
    return [];
  }

  const raidMeta = RAID_METADATA_BY_SLUG[props.raidSlug];
  if (!raidMeta?.partitions?.length) {
    return [];
  }

  const promises = raidMeta.partitions.map(
    (partition) =>
      new Promise((resolve, reject) => {
        const loadParams: any = {
          raid: props.raidSlug,
          difficulty: props.difficulty,
          region: props.region,
          realm: props.realm || 'all',
          limit: 5,
          faction: '',
          page: 0,
          recent: false,
          partition: partition.slug
        };

        apiService.getRaidInstanceRankings(loadParams, (err, data: any) => {
          if (err) {
            reject(err);
          } else {
            resolve([
              createActionGetRaidRankings(
                `frontpage:raid:partition:${props.region}:${loadParams.realm}:${props.raidSlug}:${partition.slug}`,
                data.raidRankings
              )
            ]);
          }
        });
      })
  );

  return _.flatten(await Promise.all(promises));
};
